//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import { date } from "quasar";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import MembersListInfo from "@/components/tasks/membersListInfo/membersListInfo.vue";
import submitComment from "./submitComment.vue";
import TimelineDataModel from "./TimelineDataModel.vue";
import TimelineProcessModal from "./TimelineProcessModal.vue";

export default {
    components: {
        submitComment,
        AQTooltip,
        TimelineDataModel,
        MembersListInfo,
        AQChip,
        TimelineProcessModal
    },
    filters: {
        date: (value) => `${date.formatDate(value, "DD.MM.YYYY")} at ${date.formatDate(value, "HH:mm:ss")}`
    },
    props: {
        taskDetails: {
            type: Object,
            default: () => {}
        },
        parentTaskDetails: {
            type: Object,
            default: () => {}
        },
        index: {
            type: Number,
            default: 0
        },
        isApprovalMatrix: Boolean,
        isFirstLevelExpand: {
            type: Boolean,
            default: false
        },
        isFromPI: {
            type: Boolean,
            default: false
        },
        applicationId: {
            type: String,
            default: ""
        }
    },

    data() {
        return {
            showDataModel: "",
            remainingUsersToShow: [],
            showProcessModal: false,
            instanceID: "",
            instanceName: ""
        };
    },
    computed: {
        ...mapState("components", ["isSmallScreen"]),
        checkIfSmsEmail() {
            return this.taskDetails.actionTaken === "SMS" || this.taskDetails.actionTaken === "EMAIL";
        },
        checkIfApi() {
            return (this.taskDetails.actionTaken === "Response" || this.taskDetails.actionTaken === "Request")
            && this.parentTaskDetails.type !== "BLOCKCHAIN_PLUGIN" && this.parentTaskDetails.type !== "BLOCKCHAIN_EVENT_PLUGIN";
        },
        checkUsersToShow() {
            let usersToShow = false;
            if (this.taskDetails.actionTaken !== "DOCUMENT_UPLOADED" && this.taskDetails.actionTaken !== "DOCUMENT_GENERATED") {
                usersToShow = (this.taskDetails.actionTaken === "CLAIM" || !this.checkIfAsignees) && this.checkIfExecutedSystem;
            }
            return usersToShow;
        },
        checkIfTaskExpired() {
            return this.taskDetails.actionTaken !== "TASK_TIMER_TRIGGERED";
        },
        checkUsersSystem() {
            let usersToShowSystem = false;
            if (this.taskDetails.actionTaken !== "DOCUMENT_UPLOADED" && this.taskDetails.actionTaken !== "DOCUMENT_GENERATED") {
                usersToShowSystem = !this.checkIfAsignees && this.taskDetails.actionTaken;
            }
            return usersToShowSystem;
        },
        getAssignedUsers() {
            return this.taskDetails.asignees.length > 2 ? this.taskDetails.asignees.slice(0, 2) : this.taskDetails.asignees;
        },
        checkIfAsignees() {
            return this.taskDetails.asignees && this.taskDetails.asignees.length;
        },
        checkIfExecutedSystem() {
            let executedSystem = false;
            if (this.taskDetails.executedBy && (this.taskDetails.executedBy.name || this.taskDetails.executedBy.email)) {
                executedSystem = this.taskDetails.executedBy.name.trim().normalize() !== "System";
            }
            return executedSystem;
        },
        getGeneratedUploaded() {
            let msg;
            if (this.taskDetails.actionTaken === "DOCUMENT_UPLOADED") {
                msg = this.$t("timeline.uploadedBy");
            } else {
                msg = this.$t("timeline.generatedBy");
            }
            return msg;
        },
        checkIfCapitalize() {
            return !this.checkIfSmsEmail
                && !(this.parentTaskDetails.type === "API_PLUGIN" || this.parentTaskDetails.type === "BLOCKCHAIN_PLUGIN"
                || this.checkIfApi || this.parentTaskDetails.type === "BLOCKCHAIN_EVENT_PLUGIN");
        },
        checkSubmitBy() {
            let linkWord = "";
            if (this.taskDetails.asignees && this.taskDetails.asignees.length && this.taskDetails.actionTaken !== "CLAIM") {
                linkWord = "assignedTo";
            } else {
                linkWord = "submitBy";
            }
            return this.$t(`timeline.${linkWord}`);
        },
        checkIfUsing() {
            return (this.parentTaskDetails.type === "API_PLUGIN" || this.checkIfApi) && this.taskDetails.timelineTaskDetailsImp;
        },
        checkExistingDelegation() {
            return this.taskDetails.actionTaken === "DELEGATION" ? this.$t("timeline.onBehalfOf") : this.$t("timeline.submitBy");
        }
    },
    watch: {
        taskDetails: {
            handler(newValue) {
                if (newValue && newValue.asignees && newValue.asignees.length) {
                    this.remainingUsersToShow = newValue.asignees.slice(1, newValue.asignees.length);
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        openComment(event, commInstanceId) {
            if (event.currentTarget.classList.contains("comment-opened")) {
                event.currentTarget.classList.remove("comment-opened");
                event.currentTarget.classList.remove("text-white");
                event.currentTarget.classList.add("text-black");
            } else {
                event.currentTarget.classList.add("comment-opened");
                event.currentTarget.classList.add("text-white");
                event.currentTarget.classList.remove("text-black");
            }
            if (this.$refs && this.$refs[commInstanceId] && this.$refs[commInstanceId] && this.$refs[commInstanceId].$el) {
                const instance = this.$refs[commInstanceId].$el;
                if (instance.classList.contains("comment-closed")) {
                    instance.classList.remove("comment-closed");
                } else {
                    instance.classList.add("comment-closed");
                }
            }
        },
        addMsgBgColor(value) {
            return value === "SMS" ? "background-color: #00CC66" : "background-color: #4285F4";
        },
        downloadDoc(id) {
            window.open(`/data/attachment/download/attachment/${id}`);
        },
        openSubprocessModal(taskDetails) {
            if (taskDetails.actionTaken === "START_SUBPROCESS") {
                this.instanceID = taskDetails.timelineTaskDetailsImp.startedProcessInstanceId;
                this.instanceName = taskDetails.timelineTaskDetailsImp.startedProcessDefinitionName;
                this.showProcessModal = true;
            }
        },
        getChipProps(user, fromDelegation) {
            let typeToReturn = "user";
            let contentToReturn = this.$t("timeline.system");
            if (user) {
                if (user.name && user.name === "System") {
                    typeToReturn = "default";
                } else if ((fromDelegation && user.delegatorStatus && user.delegatorStatus === "DISABLED") || (user.status && user.status === "DISABLED")) {
                    typeToReturn = "disabledUser";
                } else if ((user.type && user.type === "USER") || this.checkIfSmsEmail) {
                    typeToReturn = "user";
                } else if (user.type && user.type === "GROUP") {
                    typeToReturn = "group";
                }
                if (fromDelegation) {
                    contentToReturn = user.delegatorName;
                } else {
                    contentToReturn = user.name.trim() ? user.name.trim() : user.email;
                }
            }
            return {
                type: typeToReturn,
                content: contentToReturn
            };
        }
    }
};
